<template>
    <div class="OfficeAdd" v-if="lang">
        <div class="header col-sm-12 header-mobile" style="padding: 15px; margin-bottom: 30px">
            <aside class="step">
                <div :class="[ 'circle', { 'active': 0 <= data.activeTab }]">&nbsp;</div>
                <span :class="{ 'active': 0 <= data.activeTab }">{{ translate.pages.diary.add.tabs.office.title }}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div :class="[ 'circle', { 'active': 1 <= data.activeTab }]">&nbsp;</div>
                <span :class="{ 'active': 1 <= data.activeTab }">{{ translate.pages.diary.add.tabs.patient.title }}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div :class="[ 'circle', {'active' : 2 <= data.activeTab }]">&nbsp;</div>
                <span :class="{'active': 2 <= data.activeTab }">{{ translate.pages.diary.add.tabs.appointment.title }}</span>
            </aside>
            <aside class="navigation"></aside>
            <aside class="step">
                <div :class="[ 'circle', { 'active': 3 <= data.activeTab }]">&nbsp;</div>
                <span :class="{ 'active': 3 <= data.activeTab }">{{ translate.pages.diary.add.tabs.status.title }}</span>
            </aside>
        </div>
        <div class="clearfix"></div>
        <div class="content col-sm-12" style="padding: 15px;">
            <div v-show="data.activeTab === 0" class="col-sm-12">
                <header class="content-header">
                    <h3>{{ translate.pages.diary.add.tabs.office.subtitle }}</h3>
                </header>
                <br>
                <md-input-container>
                    <md-icon style="margin-right: 10px;">perm_contact_calendar</md-icon>
                    <label>{{ translate.pages.diary.add.fields.office }}</label>
                    <md-select name="consulta" id="consulta" v-model="consulta.office_id" >
                        <md-option v-for="office in data.listconsultorio" :value="office.id" :key="office.id">
                            {{office.name}}
                        </md-option>
                    </md-select>
                   
                    <span class="md-error" v-if="errors.office">{{ errors.office }}</span>
                </md-input-container>
                <br>
                <br>
                <br>
                <br>
            </div>
            <div v-show="data.activeTab === 1" class="col-sm-12">
                <header class="content-header">
                    <h3>{{ translate.pages.diary.add.tabs.patient.subtitle }}</h3>
                </header>
                <br>
                <md-input-container :class="{ 'md-input-invalid' : errorsPatient.hasOwnProperty('code') }">
                    <label class="label-mini">{{ translate.pages.diary.add.fields.code }}</label>
                    <md-input v-model="patient.code" @change="changeCodePatient()"></md-input>
                    
                    <span class="clearfix register_patient_wrap"
                        v-if="errorsPatient.code"
                        :class="['md-error', 'register_patient_error', { 'code_active': data.activeCode === 1 }]">
                        <span class="msg">{{ errorsPatient.code }}</span>
                        <button
                            v-if="patient.code.length >= 8 && data.activeCode === 0 && !errors.invalid_code"
                            class="md-button md-raised md-warn md-theme-default register_patient_btn"
                            @click="showModal()">{{ translate.pages.diary.add.actions.create_patient }}
                        </button>
                        <div style="clear:both"></div>
                    </span>
                </md-input-container>
                <br>
                <br>
                <br>
                <br>
                <br>
            </div>
            <div v-show="data.activeTab === 2" class="col-sm-12">
                <header class="content-header">
                    <h3>{{ translate.pages.diary.add.tabs.appointment.subtitle }}</h3>
                </header>
                <br>

                <!-- DATEPICKER -->
                <div class="col-sm-6 amolpicker container-date" style="margin-top: 10px !important">
                    <label>{{ translate.pages.diary.add.fields.date }}</label>
                    <md-icon class="icon-calendar">today</md-icon>
                    <date-picker :option="option" class="picker" :date="startDate" v-model="consulta.fecha" placeholder="--"></date-picker>
                    <small class="small-error" v-if="errors.fecha">{{ errors.fecha }}</small>
                </div>

                <div class="col-sm-6">
                    <md-input-container class="datepicker--block" style="padding 6px 0; margin-top: 12px;" :class="{ 'md-input-invalid' : errors.hasOwnProperty('hora') }">
                        <md-icon style="margin-right: 10px;">access_time</md-icon>
                        <label>{{ translate.pages.diary.add.fields.hour }}</label>
                        <md-select name="hora" id="patient_hora" v-model="consulta.hora" :disabled="consulta.disabled.hora">
                            <md-option v-for="(hour,index) in consulta.hours" :key="index" :value="hour">{{ hour }}</md-option>
                        </md-select>
                    </md-input-container>
                    <span class="md-error" v-if="errors.hora">{{ errors.hora }}</span>
                </div>
                <div class="clearfix"></div>
                <br>
            </div>
            <div v-show="data.activeTab === 3" class="col-sm-12">
                <header class="content-header">
                    <h3>{{ translate.pages.diary.add.tabs.status.subtitle }}</h3>
                </header>
                <br>
                <md-input-container style="margin-bottom: 20px !important" :class="{ 'md-input-invalid' : errors.hasOwnProperty('status') }">
                    <label>{{ translate.pages.diary.add.fields.status }}</label>
                    <md-select name="patient_status" id="patient_status" v-model="consulta.status">
                        <md-option value="1">{{ translate.pages.diary.add.statuses.await }}</md-option>
                        <md-option value="2">{{ translate.pages.diary.add.statuses.inoffice }}</md-option>
                        <md-option value="3">{{ translate.pages.diary.add.statuses.nopresent }}</md-option>
                        <md-option value="4">{{ translate.pages.diary.add.statuses.cancel }}</md-option>
                        <md-option value="5">{{ translate.pages.diary.add.statuses.reschedule }}</md-option>
                        <md-option value="6">{{ translate.pages.diary.add.statuses.complete }}</md-option>
                    </md-select>
                    <span class="md-error" v-if="errors.status">{{ errors.status }}</span>
                </md-input-container>
                <md-input-container style="margin-bottom: 20px !important" :class="{ 'md-input-invalid' : errors.hasOwnProperty('comment') }">
                    <label>{{ translate.pages.diary.add.fields.comment }}</label>
                    <md-input v-model="consulta.comment"></md-input>
                    <span class="md-error" v-if="errors.comment">{{ errors.comment }}</span>
                </md-input-container>
                <br>
            </div>
            <br>
            <footer class="content-footer">
                <hr>
                <div class="buttons clearfix">
                    <md-button class="md-raised pull-left md-size btn--gray" v-on:click.native="backStep" v-show="data.activeTab !== 0">
                        <md-icon>keyboard_arrow_left</md-icon>
                        {{ translate.actions.previous }}
                    </md-button>
                    <md-button class="md-raised md-primary pull-right btn--blue md-size" v-on:click.native="nextStep" v-show="data.activeTab !== 3" :disabled="process">
                        {{ translate.actions.next }}
                        <md-icon>keyboard_arrow_right</md-icon>
                    </md-button>
                    <md-button class="md-raised md-primary pull-right btn--blue md-size" v-on:click.native="sendStep" v-show="data.activeTab === 3" :disabled="process">
                        {{ translate.actions.add }}
                        <md-icon>keyboard_arrow_right</md-icon>
                    </md-button>
                </div>
            </footer>
        </div>
        <div id="myModal" class="mt-modal">
            <div class="mt-modal-content">
                <span class="mt-close" @click="closeModal">&times;</span>
                <div class="col-sm-12">
                    <header class="content-header">
                        <h3 class="dialog--title" style="border-bottom: 1px solid #E5E5E5; padding-bottom: 10px">Registro Paciente</h3>
                    </header>
                </div>
                <div class="col-sm-6">
                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('code') }">
                        <label>{{ translate.pages.diary.add.fields.code }}</label>
                        <md-input v-model="patient.code" @change="changeCodePatient(1)"></md-input>
                        <span class="md-error" v-if="errors.code">{{ errors.code }}</span>
                    </md-input-container>
                </div>
                <div class="col-sm-6">
                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('name') }">
                        <label>{{ translate.pages.diary.add.fields.name }}</label>
                        <md-input v-model="patient.name"></md-input>
                        <span class="md-error" v-if="errors.name">{{ errors.name }}</span>
                    </md-input-container>
                </div>
                <div class="col-sm-6">
                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('lastname') }">
                        <label>{{ translate.pages.diary.add.fields.lastname }}</label>
                        <md-input v-model="patient.lastname"></md-input>
                        <span class="md-error" v-if="errors.lastname">{{ errors.lastname }}</span>
                    </md-input-container>
                </div>
                <div class="col-sm-6">
                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('lastname2') }">
                        <label>{{ translate.pages.diary.add.fields.lastname2 }}</label>
                        <md-input v-model="patient.lastname2"></md-input>
                        <span class="md-error" v-if="errors.lastname2">{{ errors.lastname2 }}</span>
                    </md-input-container>
                </div>
                <div class="col-sm-6">
                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('gender') }">
                        <label>{{ translate.pages.diary.add.fields.gender }}</label>
                        <md-select v-model="patient.gender">
                            <md-option value="Masculino">{{ translate.pages.diary.add.genders.male }}</md-option>
                            <md-option value="Femenino">{{ translate.pages.diary.add.genders.female }}</md-option>
                        </md-select>
                        <span class="md-error" v-if="errors.gender">{{ errors.gender }}</span>
                    </md-input-container>
                </div>
                <div class="col-sm-6">
                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('email') }">
                        <label>{{ translate.pages.diary.add.fields.email }}</label>
                        <md-input v-model="patient.email"></md-input>
                        <span class="md-error" v-if="errors.email">{{ errors.email }}</span>
                    </md-input-container>
                </div>
                <!-- DATEPICKER -->
                <div class="col-sm-6 amolpicker container-date" style="margin-top: 7px !important">
                    <label style="font-size:13px;">Fecha de Nacimiento{{ translate.pages.diary.add.fields.birthDate }}</label>
                    <md-icon class="icon-calendar">today</md-icon>
                    <date-picker :option="option" class="picker" :date="birthDate" v-model="patient.birth_date"></date-picker>
                    <span class="md-error" v-if="errors.birth_date" style="font-size:0.9em">{{ errors.birth_date }}</span>
                    <br>
                </div>
                <div class="col-sm-6" style="margin-top: 4px">
                    <md-input-container :class="{ 'md-input-invalid' : errors.hasOwnProperty('phone') }">
                        <label>{{ translate.pages.diary.add.fields.phone }}</label>
                        <md-input type="number" 
                        v-validate
                        data-vv-name="phone"
                        data-vv-rules="required|numeric|min:6|max:12"
                        v-model="patient.phone"
                        required
                        ></md-input>
                        
                        <span class="md-error" v-if="errors.phone">{{ _errors.first('phone') }}</span>
                        <br>
                    </md-input-container>
                </div>
                <div class="clearfix"></div>
                <div class="col-sm-12">
                    <footer class="content-footer">
                        <hr>
                        <div class="buttons clearfix">
                            <md-button class="md-raised md-size sm-size mt-btn-second pull-left btn--gray" v-on:click.native="closeModal">{{ translate.actions.cancel }}</md-button>
                            <md-button class="md-raised md-size sm-size mt-btn-primary pull-right btn--blue" v-on:click.native="savePatient" :disabled="process">{{ translate.actions.save }}</md-button>
                        </div>
                    </footer>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>
<script>
    var language = window.navigator.userLanguage || window.navigator.language;
    import { login, doctor, patient } from '../../../config/api.js';
    import _ from 'lodash';
    import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue';
    import { datepicker, options } from '../../../config/datepicker.js';
    import {validate_chile} from '../../../config/validators.js';

    const swal = require('sweetalert2');

    // Get the modal
    var modal = document.getElementById('myModal');
    window.onclick = function(event) {
        if (event.target == modal) {
            modal.style.display = "none";
        }
    }
    export default {
        components: {
            'date-picker': myDatepicker
        },
        data() {
            return {
                process: false,
                option: options,
                startDate: { time: datepicker.now_format },
                birthDate: { time: '' },
                language: 'es',
                alert: {
                    msg : '',
                },
                consulta: {
                    office_id: '',
                    patient_id: '',
                    fecha: '',
                    hora: '',
                    status: '',
                    comment: '',
                    disabled: {
                        hora: true
                    },
                    hours: []
                },
                patient: {
                    code: '',
                    name: '',
                    lastname: '',
                    lastname2: '',
                    gender: '',
                    email: '',
                    birth_date: '',
                    phone: '',
                    type_reference: 'generic',
                    type_register: 'register'
                },
                profile_image: 'http://localhost/api-amol/public/avatar/default.jpg',
                data: {
                    listconsultorio : [],
                    confirmation : {
                        isSuccess : false,
                        isError : false,
                    },
                    activeTab : 0,
                    activeCode : 0,
                },
                errors: {
                    office  : '',
                    patient : '',
                    fecha   : '',
                    hora    : '',
                    status  : '',
                    comment : '',
                    code: '',
                    name: '',
                    lastname: '',
                    lastname2: '',
                    gender: '',
                    email: '',
                    birth_date: '',
                    phone: '',
                },
                errorsPatient: {
                    code: '',
                },
                route: {
                    doctor: doctor,
                    patient: patient,
                }
            }
        },
        mounted(){
            self = this;
            // Get specialities by country
            this.$http.get('/specialities?country='+this.$route.params.country)
                .then(response => {
                    if(response.data.status == "OK"){
                        self.data.listspecialities = response.data.data;
                    }
                });
            let url = this.route.doctor.api.list.office;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
            }
            // Get list office
            this.$http.get(url, {
                    headers: {
                        Authorization : 'Bearer '+ this.$auth.getToken(),
                    }
                }).then(response => {
                    if(response.data.status == "OK"){
                        self.data.listconsultorio = response.data.data;

                    }
                });
        },
        computed: {
            translate(){
            // Get language
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Open Modal
            openDialog(ref) {
                this.$refs[ref].open();
            },
            // Close Modal
            closeDialog(ref) {
                this.$refs[ref].close();
                self.alert.msg = '';
            },
            onOpen() {
                //console.log('Opened');
            },
            onClose(type) {
                //console.log('Closed', type);
            },
            // Submit form
            submit(){
                let url = '/admin/doctor/'+ this.doctor.id;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.$http.put(url, this.doctor, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        if(response.data.status == "OK"){
                            self.data.confirmation.isSuccess = true;
                            self.data.confirmation.isError   = false;
                            self.alert.msg = response.data.msg;
                        }else{
                            self.data.confirmation.isSuccess = false;
                            self.data.confirmation.isError   = true;
                            self.alert.msg = response.data.msg;
                        }
                        this.openDialog('dialog1');
                    }).catch(error => {
                        console.log(error);
                    });
            },
            // Change code patient
            changeCodePatient: _.debounce(
                function (type) {
                    var validation = true
                    this.errors.invalid_code = false;
                    if(window.countryCODE == "cl"){
                        validation = validate_chile(this.patient.code);
                    }
                    if(!validation){
                        this.errors.invalid_code = true;
                        this.errorsPatient.code = "RUT no valido"; //trabajar translate de esto
                        this.data.activeCode = 0
                        this.process = true
                        console.log("no validoooo")
                        return;
                    }
                    else {
                        this.process = false
                    }

                    var type = type || 0
                    this.$http.post(this.route.doctor.api.patient.exists, { code: this.patient.code, type: type, country: window.countryCODE })
                        .then((response) => {
                            this.errorsPatient.code = this.translate.pages.diary.add.validations.valid_patient+' "' + response.data.patient.name +' '+ (response.data.patient.lastname ? response.data.patient.lastname : '') +' '+ (response.data.patient.lastname2 ? response.data.patient.lastname2 : '') +'"';
                            if(type == 1)
                                this.errors.code = false;
                            this.consulta.patient_id = response.data.patient.id;
                            this.data.activeCode = 1;
                        }).catch(error => {
                            console.log(error);
                            if(error.response){
                                if(error.response.status = 422){
                                    if(type == 0)
                                        this.errorsPatient.code = error.response.data.code[0];
                                    if(type == 1)
                                        this.setErrors(error.response.data);
                                    this.consulta.patient_id = '';
                                    this.data.activeCode = 0;
                                }
                            }
                        });
                },
                500
            ),
            // Back day
            backStep(e){
                this.data.activeTab -= 1;
            },
            // Next day
            nextStep(e){
                var error = false;
                if(this.data.activeTab == 0){
                    if(this.consulta.office_id == ""){
                        error = true;
                        this.errors.doctor = this.translate.pages.diary.add.validations.no_office;
                    }else{
                        this.errors.doctor = '';
                    }
                }else if(this.data.activeTab == 1){
                    if(this.consulta.patient_id == ""){
                        error = true;
                        this.errorsPatient.code = this.translate.pages.diary.add.validations.no_patientcode;
                    }else{
                        this.getHours();
                    }
                }else if(this.data.activeTab == 2){
                    this.consulta.fecha = this.startDate.time;
                    if(this.consulta.fecha == ""){
                        error = true;
                        this.errors.fecha = this.translate.pages.diary.add.validations.no_date;
                    }else{
                        this.errors.fecha = '';
                    }
                    if(this.consulta.hora == ""){
                        error = true;
                        this.errors.hora = this.translate.pages.diary.add.validations.no_time;
                    }else{
                        this.errors.hora = '';
                    }
                }

                if(error === false)
                    this.data.activeTab += 1;
            },
            // Send day
            sendStep(e){
                var error = false;
                if(this.data.activeTab == 3){
                    if(this.consulta.status == ""){
                        error = true;
                        this.errors.status =this.translate.pages.diary.add.validations.no_status;
                    }
                    if(this.consulta.comment.lenght < 5){
                        error = true;
                        this.errors.comment = this.translate.pages.diary.add.validations.no_comment;;
                    }
                }
                if(error == false){
                    let url = this.route.doctor.api.diary.store;
                    let parent = this.$auth.getParent();
                    if(parent)
                    {
                        url += '?parent=' + parent;
                    }
                    this.process = true;
                    this.$http.post(url, this.consulta, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                        })
                        .then(response => {
                            this.process = false;
                            if(response.data.status == "OK"){
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.$router.push({'name': 'Agenda'});
                                    }, (dismiss) => {
                                        this.$router.push({'name': 'Agenda'});
                                    });
                            }else{
                                 swal('', response.data.msg, 'error')
                                    .then( () => {
                                        this.$router.push({'name': 'Agenda'});
                                    }, (dismiss) => {
                                        this.$router.push({'name': 'Agenda'});
                                    });
                            }
                            self.data.activeTab = 1;
                        }).catch(error => {
                            this.process = false;
                            console.log(error);
                            if(error.response){
                                if(error.response.status = 422){
                                    this.setErrors(error.response.data);
                                }
                            }
                        });
                }
            },
            // Show modal
            showModal(){
                this.changeCodePatient(1);
                // show modal
                var modal            = document.getElementById('myModal');
                modal.style.display  = "block";
                var _body            = document.getElementsByTagName("BODY")[0];
                _body.style.overflow = "hidden";
            },
            // Close modal
            closeModal(){
                var modal            = document.getElementById('myModal');
                modal.style.display  = "none";
                var _body            = document.getElementsByTagName("BODY")[0];
                _body.style.overflow = "auto";
            },
            // Store patient
            savePatient(){
                this.patient.country = this.$route.params.country.toUpperCase();
                this.patient.birth_date = this.birthDate.time;
                let url = this.route.patient.api.register;
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                this.process = true;
                this.$http.post(url, this.patient)
                    .then(response => {
                        this.process = false;
                        if(response.data.status == "OK"){
                            let data = response.data.data;
                            swal('', response.data.msg, 'success')
                            .then( () => {
                                self.changeCodePatient();
                                self.closeModal();
                                // this.$router.push({'name': 'Agenda'});
                            }, (dismiss) => {
                                // this.$router.push({'name': 'Agenda'});
                            });
                        }else{
                            swal('', response.data.msg, 'error')
                            .then( () => {
                                // this.$router.push({'name': 'Agenda'});
                            }, (dismiss) => {
                                // this.$router.push({'name': 'Agenda'});
                            });
                        }
                    }).catch(error => {
                        this.process = false;
                        if(error.response){
                            if(error.response.status = 422){
                                this.setErrors(error.response.data);
                            }else{
                                console.log(error);
                            }
                        }else{
                            console.log(error);
                        }
                    });
            },
            // Set errors
            setErrors: function(data){
                var self = this;
                // reset errors
                Object.keys(self.errors).map(function(objectKey, index) {
                    self.errors[objectKey] = null;
                });
                let result = {};
                for(let error in data)
                {
                    let msg = "";
                    for(let elem in data[error]){
                        if(elem != 0){
                            msg += " ";
                        }
                        msg += data[error][elem];
                    }
                    if(error == 'prefix'){
                        swal('', msg, 'error')
                    }else{
                        this.errors[error] = msg;
                    }
                }
            },
            // Get hours by date and office
            getHours: function(){
                this.consulta.fecha = this.startDate.time;
                let filter = {'date': this.consulta.fecha, 'office_id':this.consulta.office_id};
                // consult
                this.$http.post('/diary/getHours', filter ,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    }).then(response => {
                        this.consulta.hora = '';
                        this.consulta.hours = response.data;
                        this.consulta.disabled.hora = false;
                    });
            }
        },
        watch: {
            'startDate.time': function(){
                this.getHours();
            }
        }
    }
</script>
<style lang="stylus">
    /*.register_patient_btn
        padding-top 10
        margin-top 10
    */
    .register_patient_error
        height 50px!important
        line-height 50px!important
        top 50px!important
        bottom: auto!important
    .mt-input-container > .vdp-datepicker > input
        width 100%!important
        border none!important
        cursor pointer!important
</style>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/boots.styl'
    .amolpicker.container-date, .amoltimer
        padding-top 0px!important
        margin-top 3px!important
    .amoltimer .md-icon, .amolpicker.container-date .md-icon
        top 25px!important

    /* Modal */
    /* Modal background */
    .mt-modal
        display none; /* Hidden by default */
        position fixed; /* Stay in place */
        z-index 101; /* Sit on top */
        padding-top 36px; /* Location of the box */
        left 0;
        top 0;
        width 100%; /* Full width */
        height 100%; /* Full height */
        overflow auto; /* Enable scroll if needed */
        background-color rgb(0,0,0); /* Fallback color */
        background-color rgba(0,0,0,0.4); /* Black w/ opacity */
    /* Modal Content */
    .mt-modal-content
        height: auto;
        overflow-y: visible;
        background-color #fefefe;
        margin auto;
        padding 20px;
        border 1px solid #888;
        width auto;
        max-width 600px
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
        border 1px solid #cbd0d6
        -webkit-border-radius 5px
        -moz-border-radius 5px
        border-radius 5px
        .md-input-container.md-theme-default
            margin-bottom 24px

    @media (max-width: 600px)
        .mt-modal-content
            max-width calc(100vw - 20px)
    .mt-close
        color #aaaaaa;
        float right;
        font-size 28px;
        font-weight bold;


    .marcaagua{
    font-size: 10px;
    color: gray;
    }
    .mt-close:hover,
    .mt-close:focus
        color #000;
        text-decoration none;
        cursor pointer;

    @-webkit-keyframes animatetop
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}

    @keyframes animatetop
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    /* Modal */
    /* FIX DATEPICKER */
    .mt-input-container > .vdp-datepicker > input
        width 100%!important
        border none!important
        cursor pointer!important
        background-color transparent!important
    .mt-input-container > label
        pointer-events auto
        top 6px
        opacity 1
        font-size 12px
        color #959ea6 !important
        position absolute
        /* left 0 */
        transition all .4s cubic-bezier(.25,.8,.25,1)
    .mt-input-container:after
        position absolute
        margin-left 15px
        margin-right 15px
        left 0
        height 1px
        right 0
        bottom 0
        background-color #cbd0d6 !important
        content " "
    /* FIX DATEPICKER */
    .md-error
        color #ff5722!important
        opacity 1!important
        display block!important
    .code_active
        color color_confirm!important
    .OfficeAdd
        padding 3em 2.5em
        .header
            border 1px solid color_form_border
            border-radius 5px
            display flex
            font-size .9em
            font-weight bold
            justify-content space-around
            padding 1em 2em
            .step
                display flex
                /*cursor pointer*/
                .circle
                    border 1px solid color_form_border
                    border-radius 50%
                    height 18px
                    margin-right .5em
                    width 18px
                    &.active
                        background color_confirm
                        border-color color_confirm
                .active
                    color color_confirm
            .navigation
                height 2px
                background color_form_border
                min-width 8% !important
                margin-top .75em
        .content
            border 1px solid color_form_border
            border-radius 5px
            padding 1em 2em
            .h10
                height 10%
            .error
                color color_error
            &-header
                h3
                    margin-bottom 1em
            &-main
                .container
                    padding 0.25em 1em
                    .multiple
                        border 1px solid color_form_border
                        border-radius 5px
                        width 100%
                        .title
                            margin 0.5em
                            color color_form_placeholder
                        .select
                            overflow-y scroll
                            overflow-x hidden
                            margin 0.25em
                            height 110px
                            .option
                                width 95%
                                margin 0.25em
                    .subtitle
                        margin-top .5em
                        color color_form_placeholder
            &-footer
                margin-top 2em
                hr
                    background color_form_border
                    margin-bottom 1em
                    opacity 0.5
                min-height 5em
                .return
                    float left
                .next
                    float right
                    button
                        background color_main !important
                        color white
</style>



// WEBPACK FOOTER //
// Add.vue?0a342ca0